import { t } from "@lingui/core/macro";
import { useAtomValue, useSetAtom } from "jotai";
import { lowerCase, startCase } from "lodash";
import { useMemo } from "react";

import { updateDiningDietaryTags } from "@/features/BookingWizard/DiningBookingWizard/atoms/actions/updateDiningDietaryTags/updateDiningDietaryTags";
import { getDiningDietaryTags } from "@/features/BookingWizard/DiningBookingWizard/atoms/selectors/getDiningDietaryTags/getDiningDietaryTags";
import { DiningBookingWizard } from "@/features/BookingWizard/DiningBookingWizard/types";
import { PillSelect } from "@whoosh/design-system/src/components/controls/PillSelect";
import { Text, VStack } from "@whoosh/design-system/src/components/primitive";

type Props = {
  options: DiningBookingWizard.DiningBookingWizardData["dietaryTags"];
};

export const DiningWizardDietaryTagsControl = ({ options }: Props) => {
  const selectedDietaryTags = useAtomValue(getDiningDietaryTags);
  const setDietaryTags = useSetAtom(updateDiningDietaryTags);

  const pillOptions = useMemo(
    () =>
      options.map((option) => ({
        label: startCase(lowerCase(option)),
        value: option,
      })),
    [options]
  );

  return (
    <VStack gap={4} backgroundColor="surface-primary">
      <Text variant="mainBaseSemiBold">{t`Do you have any allergies?`}</Text>
      <PillSelect
        options={pillOptions}
        values={selectedDietaryTags}
        setValues={setDietaryTags}
        allowAddition={false}
        placeholder={t`Search dietary tags`}
      />
    </VStack>
  );
};
